export default "__VITE_ASSET__fea6fe75__"